import { configureStore } from '@reduxjs/toolkit';
import policiesReducer from './policiesReducer';
import authReducer, { logout } from './authReducer';
import { setLogoutHandler } from '../helpers/request';

const store = configureStore({
  reducer: {
    policies: policiesReducer,
    auth: authReducer
  },
});

setLogoutHandler(() => {
  store.dispatch(logout());
});

export default store;